import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { Params, RouterLink } from '@angular/router';

@Component({
  selector: 'core-scroll-to',
  imports: [NgbTooltip, RouterLink],
  templateUrl: './scroll-to.component.html',
  styleUrl: './scroll-to.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScrollToComponent {
  tooltip = input<string>('');
  fragment = input<string>('');
  count = input<string | number>(0);
  routerLink = input<string[]>([]);
  queryParams = input<Params | null>();
}
